(() => {
  const el = document.getElementById('selling-dates');
  if (!el) return;

  let data;
  try {
    data = JSON.parse(el.textContent);
  } catch {
    return;
  }

  const productId = data.productId;
  const start = data.start !== null ? Number(data.start) * 1000 : null;
  const end = data.end !== null ? Number(data.end) * 1000 : null;
  const serverNow = data.serverNow !== null ? Number(data.serverNow) * 1000 : null;
  const MAX_TIMEOUT = 2_147_000_000;

  if (!productId || !serverNow || (!start && !end)) return;

  const keyStart = `__selling_start_reloaded__:${productId}`;
  const keyEnd = `__selling_end_reloaded__:${productId}`;

  let timeoutId = null;

  // JSがこの値を読んだ瞬間の高精度時刻
  const perfBase = performance.now();

  // サーバー現在時刻 + ページ表示後の経過時間
  const now = () => serverNow + (performance.now() - perfBase);

  const get = (key) => {
    try {
      return sessionStorage.getItem(key);
    } catch (_) {
      return null;
    }
  };

  const set = (key, value) => {
    try {
      sessionStorage.setItem(key, String(value));
    } catch (_) {}
  };

  const reload = () => {
    location.href = location.href.split('#')[0];
  };

  const check = () => {
    const current = now();

    if (start && current >= start && get(keyStart) !== String(start)) {
      set(keyStart, start);
      reload();
      return true;
    }

    if (end && current >= end && get(keyEnd) !== String(end)) {
      set(keyEnd, end);
      reload();
      return true;
    }

    return false;
  };

  const schedule = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    const current = now();
    const targets = [];

    if (start && current < start && get(keyStart) !== String(start)) {
      targets.push(start);
    }

    if (end && current < end && get(keyEnd) !== String(end)) {
      targets.push(end);
    }

    if (!targets.length) return;

    const next = Math.min(...targets);
    const delay = Math.min(Math.max(next - current, 0), MAX_TIMEOUT);

    timeoutId = setTimeout(() => {
      if (check()) return;
      schedule();
    }, delay);
  };

  // 初回アクセス時、すでに過ぎている境界は処理済みにする
  const current = now();

  if (start && current >= start) {
    set(keyStart, start);
  }

  if (end && current >= end) {
    set(keyEnd, end);
  }

  schedule();

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return;
    if (check()) return;
    schedule();
  });

  window.addEventListener('focus', () => {
    if (check()) return;
    schedule();
  });

  window.addEventListener('pageshow', () => {
    if (check()) return;
    schedule();
  });
})();
